<!--Main Content-->
<div class="sed-Center">
	<h5>Do you want to keep email addresses using the old domain or delete them?</h5>
	<p class="sed-HelpText">Note: The old addresses might become invalid</p>
</div>
<!--Buttons-->
<div class="sed-Buttons">
	<!--Add and keep-->
	<button class="btn sed-Graybtn" (click)="onAddAndKeep()">Add and Keep</button>
	<!--Add and delete-->
	<button class="btn sed-Graybtn" (click)="onAddAndDelete()">Add and Delete</button>
	<!--Cancel/Close-->
	<button class="btn sed-Graybtn" (click)="onClose()">Cancel</button>
</div>
